import React from 'react';
import SalesActivityContainer from '../../containers/salesActivity/SalesActivityContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const SalesActivityPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="영업활동관리/영업일정등록" icon="partner" />
      <SalesActivityContainer />
    </>
  );
};

export default SalesActivityPage;
